import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Menu from "./components/Menu";
import Footer from "./components/Footer";

import ConversionPage from "./Pages/ConversionPage";
import ReductionPage from "./Pages/ReductionPage";
import MentionsLegales from "./Pages/MentionsLegales";
import Confidentialite from "./Pages/Confidentialite";
import Conditions from "./Pages/Conditions";
import CookieBanner from "./components/CookieBanner";


export default function App() {
  return (
    <div className="app-layout">
      <Menu />

      <main className="app-content">
        <Routes>
          <Route path="/" element={<Navigate to="/conversion" replace />} />
          <Route path="/conversion" element={<ConversionPage />} />
          <Route path="/reduction" element={<ReductionPage />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/conditions" element={<Conditions />} />
          <Route path="*" element={<Navigate to="/conversion" replace />} />
        </Routes>
      </main>
      <CookieBanner adsenseClientId="ca-pub-4717440096189113" />
      <Footer />
    </div>
  );
}